module.exports = __webpack_public_path__ + "static/media/overpass-heavy.7fe4082d.eot";